export const C = {
  // Backgrounds
  bg0: "#060b16",
  bg1: "#0b1120",
  bg2: "#101928",
  bg3: "#172233",

  // Accents
  blue:   "#60a5fa",
  green:  "#34d399",
  yellow: "#fbbf24",
  pink:   "#f472b6",
  purple: "#a78bfa",
  red:    "#ef4444",

  // Text
  text1: "#eef2ff",
  text2: "#8fa3c0",
  text3: "#4d6080",
  text4: "#2e4460",

  // Border
  border: "#192840",
};

export const S = {
  card: {
    background: C.bg2,
    border: `1px solid ${C.border}`,
    borderRadius: 16,
    padding: 20,
    boxShadow: "0 4px 20px rgba(0,0,0,.5), inset 0 1px 0 rgba(255,255,255,.03)",
  },
  badge: (color) => ({
    fontSize: 11,
    fontWeight: 700,
    padding: "2px 9px",
    borderRadius: 6,
    background: `${color}1e`,
    color,
    display: "inline-block",
    whiteSpace: "nowrap",
    letterSpacing: "0.2px",
  }),
  btn: (active, color = C.blue) => ({
    padding: "6px 14px",
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
    border: `1px solid ${active ? color + "60" : C.border}`,
    background: active ? `${color}18` : "transparent",
    color: active ? color : C.text3,
    transition: "all .15s",
    letterSpacing: "0.1px",
  }),
  input: {
    padding: "8px 13px",
    borderRadius: 9,
    background: C.bg1,
    border: `1px solid ${C.border}`,
    color: C.text1,
    fontSize: 13,
    outline: "none",
    transition: "border-color .15s",
  },
  th: (sortable) => ({
    color: C.text4,
    fontWeight: 600,
    textAlign: "left",
    padding: "9px 11px",
    borderBottom: `1px solid ${C.border}`,
    fontSize: 11,
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    whiteSpace: "nowrap",
    cursor: sortable ? "pointer" : "default",
    userSelect: "none",
  }),
  td: {
    padding: "10px 11px",
    borderBottom: `1px solid rgba(28,45,68,.7)`,
    verticalAlign: "middle",
  },
};

// Пустая строка = относительные URL (работает и на localhost и на продакшене через nginx)
export const BASE = "";
